import { Timestamp } from '@dixa/lib-shared-habla';
import { ConversationsChannels } from 'lib-shared-legacy-types';
import { ampli } from 'lib-shared-tracking';
import { MouseEvent } from 'react';
// eslint-disable-next-line no-restricted-imports
import { Link } from 'react-router-dom';

import { PHONE_BASED_CHANNELS } from 'app/utils/channels';
import { getConversationTitle } from 'components/conversation/conversationDetails/helpers';

import styles from '../../conversationDetails.module.scss';
import { ConversationDetailsLayout } from '../../conversationDetailsLayout';
import { SubTitleRendererParams } from '../../subTitleRenderers';

export const defaultSubTitleRenderer = ({
  metaConversation,
  layout,
  showMessageCount,
  conversationUrl,
}: SubTitleRendererParams): JSX.Element | null => {
  const { conversation } = metaConversation;
  const { last_message_created_at: lastMessageCreatedAt } = conversation;
  const {
    inboundmessagecount: inboundMessageCount,
    outboundmessagecount: outboundMessageCount,
  } = conversation;
  const titleStrings = getConversationTitle(metaConversation);
  const { subject } = titleStrings;

  const isSidebarLayout =
    layout === ConversationDetailsLayout.Sidebar ||
    layout === ConversationDetailsLayout.SidebarCollapsed;

  if (isSidebarLayout && subject) {
    return <>{subject}</>;
  }

  const separator = ' · ';

  if (
    PHONE_BASED_CHANNELS.includes(
      conversation.initial_channel as ConversationsChannels,
    ) &&
    conversation.live_assesment?.is_end_user_connected &&
    conversation.assignment?.assigned_at
  ) {
    const assignedAtDate = new Date(conversation.assignment?.assigned_at);
    return (
      <>
        {!isSidebarLayout && <>Ongoing: </>}
        <span
          onClick={() =>
            ampli.conversationsTimestampClicked({
              context: 'assigned',
            })
          }
        >
          <Timestamp time={assignedAtDate} counter refreshRate={1000} />
        </span>
      </>
    );
  }

  const CSID = metaConversation.conversation.id;
  const messageCount = (inboundMessageCount ?? 0) + (outboundMessageCount ?? 0);

  const renderConversationId = (): JSX.Element => {
    const conversationIdLabel = `#${CSID}`;

    if (!conversationUrl) {
      return <span>{conversationIdLabel}</span>;
    }

    // Stops the row click handler (which opens the preview) from firing, so
    // clicking the conversation id only navigates to the conversation.
    const stopRowClick = (event: MouseEvent<HTMLAnchorElement>) => {
      event.stopPropagation();
    };

    return (
      <Link
        to={conversationUrl}
        className={styles.conversationIdLink}
        onClick={stopRowClick}
      >
        {conversationIdLabel}
      </Link>
    );
  };

  if (CSID || lastMessageCreatedAt) {
    return (
      <>
        {CSID && renderConversationId()}

        {showMessageCount && messageCount > 0 && (
          <span>
            {separator}
            {`${messageCount} ${messageCount > 1 ? `messages` : `message`}`}
          </span>
        )}

        {lastMessageCreatedAt && (
          <>
            {separator}

            <span
              onClick={() =>
                ampli.conversationsTimestampClicked({
                  context: 'created',
                })
              }
            >
              <Timestamp relative time={lastMessageCreatedAt} />
            </span>
          </>
        )}
      </>
    );
  }

  return null;
};
